export enum MODAL_ACTION {
  Cancel = 'cancel',
  Closed = 'closed',
}
